import Dialog from './Dialog.js';

class PendingMaintenanceDialog extends Dialog {
    static create(params) {
        return new PendingMaintenanceDialog(params);
    }

    formatMsToStartTimeInWords(msToStartTime) {
        var totalMinutes = Math.floor(msToStartTime / 60 / 1000),
            hours = Math.floor(totalMinutes / 60),
            remainderMinutes = totalMinutes % 60,
            minuteString = remainderMinutes === 1 ? `${remainderMinutes} minute` : `${remainderMinutes} minutes `;

        if (hours === 0) {
            return minuteString;
        }
        else if (hours === 1) {
            return `${hours} hour, ${minuteString}`;
        }

        return `${hours} hours, ${minuteString}`;
    }

    setMsToStartTime(msToStartTime) {
        this.find('.countdown-time-remaining').text(this.formatMsToStartTimeInWords(msToStartTime));
        return this;
    }
}

export default PendingMaintenanceDialog;